import React from 'react';
import { VideoParagraph } from '../../Blog/Paragraphs/VideoParagraph';

const PluginVideos = () => {
    const pluginVideoDescription = `Оптимизация сетевой инфраструктуры: Научитесь своевременно выявлять и устранять проблемы в сетевой инфраструктуре, повышая ее производительность с помощью специальных плагинов (Netscaler, F5, Palo Alto, Cisco и другие) для сетевого оборудования.

Расширение возможностей мониторинга баз данных: Узнайте, как помимо транзакционного мониторинга добавить контроль состояния внутренних параметров баз данных с помощью плагинов. Это позволит более детально выявлять проблемы и их корневые причины, а также повысить общую эффективность мониторинга работы баз данных.

Контроль файловой системы: Фиксируйте отсутствие или изменения файлов в директориях, а также отслеживайте дату их создания, изменения и размер. Пакетная конфигурация упростит начальную настройку и поможет предотвратить возможные сбои и потерю данных.

Контроль сертификатов безопасности: Централизованно следите за сроком действия SSL/TLS сертификатов и заблаговременно получайте уведомления об их истечении. Данный плагин позволит вам превентивно реагировать на истекающие сертификаты и таким образом предотвратить возникновение массовых инцидентов.`;

    return (
        <div className="plugin-videos">
            <h2 className="text-2xl font-bold mb-4">Плагины для расширенного мониторинга</h2>
            <div className="mb-4 text-gray-600">
                Дмитрий Нетребин рассказал, как расширить возможности Единого Агента, и показал на практике, как плагины помогают извлекать дополнительную информацию из различных источников.
            </div>
            
            <div className="space-y-6">
                <div className="mb-6">
                    <VideoParagraph 
                        text={pluginVideoDescription}
                        src="/static/videos/meetup-plugins.mp4" 
                    />
                </div>
            </div>
        </div>
    );
};

export default PluginVideos;